export const notifications = {
    "tenantDetailsFor": "Detalles del inquilino - apt",
    "name": "Nombre",
    "phone": "Teléfono",
    "email": "Email",
    "renter": "Inquilino/a",
    "owner": "Propietario/a",
    "showAll": "Mostrar todos los edificios",
    "chooseBuilding": "Elegir edificio",
    "more_apartment_details": "Más detalles del apartamento",
    "sendRequest": "Enviar solicitud de pago",
    "recordPayment": "Registrar el pago",
    "charge": "Cargo de la tarjeta de crédito",
    "emptyList": "No hay registros para el edificio seleccionado",
    "sendWarningLetter": "Enviar carta de advertencia",
    "title": "Notificaciones",
    "apartment": "Apartamento",
    "warningLetterTitle": "Carta de advertencia",
    "sendWarningLetterTo": "Enviar carta de advertencia a"
};
